import { createAction } from '../../utils';
import * as types from './types';

export const openConfirmModal = createAction(types.OPEN_CONFIRM_MODAL);
export const closeConfirmModal = createAction(types.CLOSE_CONFIRM_MODAL);
